import { t } from '@/utils/lang';

export const getIsFilterOptions = () => {
    return [
        {
            id: 'true',
            value: true,
            title: t('Có'),
            label: t('Có'),
        },
        {
            id: 'false',
            value: false,
            title: t('Không'),
            label: t('Không'),
        },
    ];
};
